import * as ExcelJS from 'exceljs';
import moment from 'moment';
import { getLocalTime } from '../../../lib';
import {
  CommonStatusStep,
  DownloadPlatformType,
  IAPIUserInfo,
  IDownLoadMenu,
  IDownLoadVersionMenu,
  IStudioInfo,
} from '../../../model/api-modules';
import { messageSuccess } from '../../../components/message';

interface IGameManageExportMeta<T = Record<string, string>> {
  label: string;
  key?: string;
  getter?: (record: T) => string | string[] | undefined | null;
}

export const exportDownloadRecordXlsx = async (
  dataList: any[] = [],
  downLoadList: IDownLoadMenu[],
  downLoadVersionList: IDownLoadVersionMenu[],
  studioList: IStudioInfo[],
  userInfo: IAPIUserInfo | null
  //   site?: string
) => {
  await startExport(
    dataList,
    downLoadList,
    downLoadVersionList,
    studioList,
    userInfo
  );
};

const isJSON = (value: any) => {
  try {
    JSON.parse(value);
    return true;
  } catch (e) {
    return false;
  }
};

const getJsonToParse = (value: any) => {
  if (isJSON(value)) {
    return JSON.parse(value);
  }
  return value;
};

const startExport = async (
  dataList: any[],
  downLoadList: IDownLoadMenu[],
  downLoadVersionList: IDownLoadVersionMenu[],
  studioList: IStudioInfo[],
  userInfo: IAPIUserInfo | null
  //   site?: string
) => {
  // const studioMembers: Record<string, IRbacMemberItem[]> = {};

  const dataMeta: IGameManageExportMeta<any>[] = [
    {
      label: '下载人',
      key: 'Name',
      getter: (record) => {
        const value = getJsonToParse(record.Value);
        const emailArr = value.uid?.split('@') || [''];
        return emailArr?.[0];
      },
    },
    {
      label: '下载人邮箱',
      key: 'Uid',
      getter: (record) => {
        const value = getJsonToParse(record.Value);
        return value.uid;
      },
    },
    {
      label: '下载物名称',
      key: 'ObjectName',
      getter: (record) => {
        const value = getJsonToParse(record.Value);
        const { versionIds, recordBody, versionID } = value;
        let objectName = '';
        if (versionIds) {
          const versionItems: IDownLoadVersionMenu[] = [];
          downLoadVersionList.forEach((item) => {
            if (versionIds && versionIds.indexOf(item.id) !== -1) {
              versionItems.push(item);
            }
          });
          versionItems.forEach((item) => {
            const itemName =
              downLoadList.find((it) => it.id === item.ObjectID)?.Name || '';
            objectName += `${itemName},`;
          });
        } else if (recordBody) {
          recordBody.SdkInfo?.length !== 0 &&
            recordBody.SdkInfo.forEach((item: any) => {
              const versionItem = downLoadVersionList.find(
                (it) => it.id === item.versionID
              );
              const objItem = downLoadList.find((it) => {
                if (versionItem?.ObjectID) {
                  return it.id === versionItem?.ObjectID;
                }
                return null;
              });
              objectName += `${objItem?.Name || ''},`;
            });
        } else if (versionID) {
          const versionItem = downLoadVersionList.find(
            (it) => it.id === value.versionID
          );
          const objItem = downLoadList.find((it) => {
            if (versionItem?.ObjectID) {
              return it.id === versionItem?.ObjectID;
            }
            return null;
          });
          objectName = objItem?.Name || '';
        }
        if (objectName.endsWith(',')) {
          objectName = objectName.slice(0, -1);
        }
        return objectName || '/';
      },
    },
    {
      label: '二级下载物',
      key: 'SecondDownload',
      getter: (record) => {
        const value = getJsonToParse(record.Value);
        const { recordBody, subVersionTags } = value;
        let title = '';
        if (recordBody) {
          recordBody?.SdkInfo?.length !== 0 &&
            recordBody?.SdkInfo?.forEach((item: any) => {
              if (item?.subVersionTags?.length !== 0) {
                const subVersion = item?.subVersionTags?.join('、');
                if (subVersion) {
                  title += title ? `,${subVersion}` : subVersion;
                }
              }
            });
        } else if (subVersionTags && subVersionTags.length !== 0) {
          title = subVersionTags.join(',');
        }
        return title || '/';
      },
    },
    {
      label: '下载物版本',
      key: 'SecondDownload',
      getter: (record) => {
        const value = getJsonToParse(record.Value);
        const { versionIds, recordBody, versionID } = value;
        let version = '';
        if (versionIds) {
          const versionItems: IDownLoadVersionMenu[] = [];
          downLoadVersionList.forEach((item) => {
            if (versionIds && versionIds.indexOf(item.id) !== -1) {
              versionItems.push(item);
            }
          });
          versionItems.forEach((item) => {
            version += `${item.Version || ''},`;
            if (version.endsWith(',')) {
              version = version.slice(0, -1);
            }
          });
        } else if (recordBody) {
          recordBody?.SdkInfo?.length !== 0 &&
            recordBody?.SdkInfo?.forEach((item: any) => {
              const versionItem = downLoadVersionList.find(
                (it) => it.id === item.versionID
              );
              version += version
                ? `,${versionItem?.Version}`
                : versionItem?.Version;
            });
        } else if (versionID) {
          const versionItem = downLoadVersionList.find(
            (it) => it.id === versionID
          );
          if (versionItem) {
            version = versionItem.Version;
          }
        }
        return version || '/';
      },
    },
    {
      label: '平台',
      key: 'Platforms',
      getter: (record) => {
        const value = getJsonToParse(record.Value);
        const { platforms, engine } = value;
        let platform = '';
        if (platforms && platforms.length !== 0 && engine) {
          // 只有客户端sdk显示平台
          if (engine?.type === 1 || engine?.type === 2 || engine?.type === 3) {
            platforms.forEach((item: DownloadPlatformType) => {
              if (item === DownloadPlatformType.Android) platform += 'Android,';
              if (item === DownloadPlatformType.IOS) platform += 'iOS,';
              if (item === DownloadPlatformType.Mac) platform += 'Mac,';
              if (item === DownloadPlatformType.PS4) platform += 'PS4,';
              if (item === DownloadPlatformType.PS5) platform += 'PS5,';
              if (item === DownloadPlatformType.Switch) platform += 'Switch,';
              if (item === DownloadPlatformType.Windows) platform += 'Windows,';
              if (item === DownloadPlatformType.XSX) platform += 'XSX,';
            });
          }
        }
        if (platform.endsWith(',')) {
          platform = platform.slice(0, -1);
        }
        return platform || '/';
      },
    },
    {
      label: '引擎',
      key: 'SecondDownload',
      getter: (record) => {
        const value = getJsonToParse(record.Value);
        const { versionIds, recordBody, engine } = value;
        let versionName = '';
        if (versionIds) {
          const versionItems: IDownLoadVersionMenu[] = [];
          downLoadVersionList.forEach((item) => {
            if (versionIds && versionIds.indexOf(item.id) !== -1) {
              versionItems.push(item);
            }
          });
          versionItems.forEach((item) => {
            const engineJson = item.EngineJson[0] || [];
            if (engineJson.type === 1) {
              if (engineJson.version?.length !== 0) {
                versionName += `UE Plugin${engineJson.version},`;
              }
              // if (engineJson.pssdkVersion?.length !== 0) {
              //   versionName += `PS SDK${engineJson.pssdkVersion},`;
              // }
              // if (engineJson.gdkVersion?.length !== 0) {
              //   versionName += `GDK${engineJson.gdkVersion},`;
              // }
            } else if (engineJson?.type === 2) {
              versionName += 'C++,';
            } else if (engineJson?.type === 3) {
              versionName += 'Unity Plugin,';
            }
          });
        } else if (recordBody) {
          recordBody.SdkInfo?.length !== 0 &&
            recordBody.SdkInfo.forEach((item: any) => {
              if (item.engine?.type === 1) {
                // UEPlugin = 1,
                // CPP = 2,
                // UnityPlugin = 3,
                // Windows = 4,
                // WinMsvC = 5,
                // Zip = 6,
                if (item.engine?.version) {
                  versionName += `UE Plugin${item.engine?.version},`;
                }
                // if (item.engine?.pssdkVersion) {
                //   versionName += `PS SDK${item.engine?.pssdkVersion},`;
                // }
                // if (item.engine?.gdkVersion) {
                //   versionName += `GDK${item.engine?.pssdkVersion},`;
                // }
              } else if (item.engine?.type === 2) {
                versionName += 'C++,';
              } else if (item.engine?.type === 3) {
                versionName += 'Unity Plugin,';
              }
            });
        } else if (engine) {
          // UEPlugin = 1,
          // CPP = 2,
          // UnityPlugin = 3,
          // Windows = 4,
          // WinMsvC = 5,
          // Zip = 6,
          if (engine?.type === 1) {
            if (engine?.version) {
              versionName += `UE Plugin${engine?.version},`;
            }
            // if (engine?.pssdkVersion) {
            //   versionName += `PS SDK${engine?.pssdkVersion},`;
            // }
            // if (engine?.gdkVersion) {
            //   versionName += `GDK${engine?.pssdkVersion},`;
            // }
          } else if (engine?.type === 2) {
            versionName += 'C++,';
          } else if (engine?.type === 3) {
            versionName += 'Unity Plugin,';
          }
        }
        if (versionName.endsWith(',')) {
          versionName = versionName.slice(0, -1);
        }
        return versionName || '/';
      },
    },
    {
      label: '工作室信息',
      key: 'LinkInfo',
      getter: (record) => {
        const value = getJsonToParse(record.Value);
        const { studioId, gameName, envName } = value;
        const studioItem = studioList.find(
          (item) => item.StudioID === studioId
        );
        let linkInfo = '';
        if (studioItem?.Name) {
          linkInfo += studioItem.Name;
        }
        if (gameName) {
          linkInfo += `/${gameName}`;
        }
        if (envName) {
          linkInfo += `/${envName}`;
        }
        return linkInfo;
      },
    },
    {
      label: '下载状态',
      key: 'Status',
      getter: (record) => {
        return record.Status === CommonStatusStep.Reject ? '失败' : '成功';
      },
    },
    {
      label: '下载时间',
      getter: (record) =>
        getLocalTime(
          record.ModifyTime || record.CreateTime,
          userInfo?.UserSettings?.Timezone
        ),
    },
  ];

  const workbook = new ExcelJS.Workbook();

  generateSheet(workbook, dataMeta, dataList, '下载记录');

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = `下载记录_${moment().format('YYYYMMDDHHmmss')}.xlsx`; // 设置文件名
  a.click();

  URL.revokeObjectURL(url);
  messageSuccess('下载列表导出成功');
};

const generateSheet = (
  workbook: ExcelJS.Workbook,
  metaData: IGameManageExportMeta<any>[],
  list: any[],
  sheetName: string
) => {
  const worksheet = workbook.addWorksheet(sheetName);

  worksheet.addRow(metaData.map((item) => item.label));
  'ABCDEFGHIJKLMNOPQ'.split('').forEach((columnKey) => {
    worksheet.getColumn(columnKey).width = 26;
  });

  worksheet.getColumn('E').alignment = { wrapText: true };
  worksheet.getColumn('F').alignment = { wrapText: true };
  worksheet.getColumn('F').width = 30;
  const tableData = list.map((info) => {
    return metaData.map((meta) => {
      if (!info) {
        return '';
      }
      const cellText = meta.getter?.(info) || (info[meta.key || ''] as string);
      if (cellText instanceof Array) {
        return cellText.join('\n');
      }
      return cellText;
    });
  });

  worksheet.addRows(tableData);

  worksheet.eachRow((row) => {
    let maxLineCount = 1;

    row.eachCell((cell) => {
      cell.alignment = {
        vertical: 'top',
        horizontal: 'center',
        wrapText: true,
      };
      if (String(cell.value).includes('\n')) {
        const lines = String(cell.value).split('\n').length;
        if (lines > maxLineCount) maxLineCount = lines;
      }
    });
    // eslint-disable-next-line no-param-reassign
    row.height = maxLineCount * 15; // 基础行高 + 换行增量
  });
};
